import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { FgStatusEnum } from "@gtpl/shared-models/common-models";

@Entity('complaints')
export class ComplaintsEntity{

   @PrimaryGeneratedColumn('increment', {name: 'complaint_id'})
   complaintId: number;

   @Column('varchar', {
       nullable: false,
       length: 40,
       name: 'complaint_name'
   })
   complaint: string;

   @Column('int', {
       nullable: false,
       name: 'department_id'
   })
   departmentId: number;

   @Column('varchar', {
    nullable: true,
    length: 40,
    name: 'department_name'
   }) 
   departmentName: string;

   @Column({
       nullable: false,
       name: 'complaint_raised_date'
   })
   complaintRaisedDate: Date;

   @Column({
    type: 'enum',
    enum: FgStatusEnum,
    nullable: false,
    default: FgStatusEnum.OPEN,
    name: 'status'
   })
   status: FgStatusEnum;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}